/* eslint-disable max-lines */
/* istanbul ignore file */
import { Component } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import MuiErrorOutline from '@material-ui/icons/ErrorOutline';
import SendOutlined from '@material-ui/icons/SendOutlined';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import Message from '@material-ui/icons/Message';
import Done from '@material-ui/icons/Done';
import People from '@material-ui/icons/People';
import BarChart from '@material-ui/icons/BarChart';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ChangeHistory from '@material-ui/icons/ChangeHistory';
import ControlPoint from '@material-ui/icons/ControlPoint';
import Warning from '@material-ui/icons/Warning';
import Search from '@material-ui/icons/Search';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import HighlightOff from '@material-ui/icons/HighlightOff';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import MoreVert from '@material-ui/icons/MoreVert';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@material-ui/icons/IndeterminateCheckBoxOutlined';
import Check from '@material-ui/icons/Check';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Close, ExpandMore, ExpandLess } from '@material-ui/icons';
import { Flex } from './layout-components';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import TimelineIcon from '@material-ui/icons/Timeline';
import { ICON_SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import { ReactComponent as HandIcon } from 'images/icons-js/HandIcon.svg';
import { ReactComponent as New } from 'images/icons-js/New.svg';
import { ReactComponent as CalendarIcon } from 'images/icons-js/CalendarIcon.svg';
import { ReactComponent as CloseIcon } from 'images/icons-js/CloseIcon.svg';
import { ReactComponent as Indicators } from 'images/icons-js/IndicatorsIcon.svg';
import { ReactComponent as Wrench } from 'images/icons/wrench.svg';

import { ReactComponent as Productivity } from 'images/icons-js/Productivity.svg';
import { ReactComponent as TeamworkIcon } from 'images/icons-js/TeamworkIcon.svg';
import { ReactComponent as Throughput } from 'images/icons-js/Activity.svg';
import { ReactComponent as Checkmark } from 'images/icons-js/Checkmark.svg';
import { ReactComponent as QualityIcon } from 'images/icons-js/Quality.svg';
import { ReactComponent as NewestIcon } from 'images/icons-js/NewestIcon.svg';
import { ReactComponent as StarsBox } from 'images/icons-js/StarsBox.svg';
import { ReactComponent as HumanBubble } from 'images/icons-js/HumanBubble.svg';
import { ReactComponent as Envelope } from 'images/icons-js/Envelope.svg';
import { ReactComponent as EnvelopeWithCheckMark } from 'images/icons-js/EnvelopeWithCheckMark.svg';
import { ReactComponent as LongLivingIcon } from 'images/icons-js/LongLivingIcon.svg';
import { ReactComponent as WIPIcon } from 'images/icons-js/WipIcon.svg';
import { ReactComponent as TrialIcon } from 'images/icons-js/TrialIcon.svg';
import { ReactComponent as PeopleIcon } from 'images/icons-js/PeopleIcon.svg';
import { ReactComponent as RepositoriesIcon } from 'images/icons-js/RepositoriesIcon.svg';
import { ReactComponent as Arraw } from 'images/icons-js/Arraw.svg';
import { ReactComponent as TeamsPeopleIcon } from 'images/icons-js/TeamsPeopleIcon.svg';
import { ReactComponent as MergedUsers } from 'images/icons-js/MergedUsers.svg';
import { ReactComponent as Pencil } from 'images/icons-js/Pencil.svg';
import { ReactComponent as Onprem } from 'images/icons-js/Onprem.svg';
import { ReactComponent as Settings } from 'images/icons-js/Settings.svg';
import { ReactComponent as Success } from 'images/icons-js/Success.svg';
import { ReactComponent as Jira } from 'images/icons-js/Jira.svg';
import { ReactComponent as Clubhouse } from 'images/icons-js/Clubhouse.svg';
import { ReactComponent as Shortcut } from 'images/icons-js/Shortcut.svg';
import { ReactComponent as AzureBoards } from 'images/logos/azure-boards.svg';
import { ReactComponent as LinkIcon } from 'images/icons-js/LinkIcon.svg';
import { ReactComponent as UnlinkIcon } from 'images/icons-js/UnlinkIcon.svg';
import { ReactComponent as SuccessOutline } from 'images/icons-js/SuccessOutline.svg';
import { ReactComponent as ErrorOutline } from 'images/icons-js/ErrorOutline.svg';
import { ReactComponent as WarningOutline } from 'images/icons-js/WarningOutline.svg';
import { ReactComponent as Clipboard } from 'images/icons-js/Clipboard.svg';
import { ReactComponent as Clock } from 'images/icons-js/Clock.svg';
import { ReactComponent as ClockTime } from 'images/icons-js/ClockTime.svg';
import { ReactComponent as PeopleClock } from 'images/icons-js/PeopleClock.svg';
import { ReactComponent as Release } from 'images/icons-js/Release.svg';
import { ReactComponent as Commit } from 'images/icons-js/Commit.svg';
import { ReactComponent as PrInitiated } from 'images/icons-js/PrInitiated.svg';
import { ReactComponent as PrMerged } from 'images/icons-js/PrMerged.svg';
import { ReactComponent as PrMerged2 } from 'images/icons-js/PrMerged2.svg';
import { ReactComponent as LongReview } from 'images/icons-js/LongReview.svg';
import { ReactComponent as ReviewCommented } from 'images/icons-js/ReviewCommented.svg';
import { ReactComponent as ReviewApproved } from 'images/icons-js/ReviewApproved.svg';
import { ReactComponent as ReviewChangesRequested } from 'images/icons-js/ReviewChangesRequested.svg';
import { ReactComponent as PrClosed } from 'images/icons-js/PrClosed.svg';
import { ReactComponent as ChatOutline } from 'images/icons-js/ChatOutline.svg';
import { ReactComponent as RepoOwnerOrg } from 'images/icons-js/RepoOwnerOrg.svg';
import { ReactComponent as RepoOwnerUser } from 'images/icons-js/RepoOwnerUser.svg';
import { ReactComponent as AlarmDisabled } from 'images/icons-js/AlarmDisabled.svg';
import { ReactComponent as Alarm } from 'images/icons-js/Alarm.svg';
import { ReactComponent as AlarmFull } from 'images/icons-js/AlarmFull.svg';
import { ReactComponent as AreaChart } from 'images/icons-js/AreaChart.svg';
import { ReactComponent as Trash } from 'images/icons-js/Trash.svg';
import { ReactComponent as Refresh } from 'images/icons-js/Refresh.svg';
import { ReactComponent as Alert } from 'images/icons/alert.svg';
import { ReactComponent as Scrum } from 'images/icons-js/Scrum.svg';
import { ReactComponent as Kanban } from 'images/icons-js/Kanban.svg';
import { ReactComponent as Projects } from 'images/icons-js/Projects.svg';
import { ReactComponent as Accuracy } from 'images/icons-js/Accuracy.svg';
import { ReactComponent as Burnout } from 'images/icons-js/Burnout.svg';
import { ReactComponent as TopReviewer } from 'images/icons-js/TopReviewer.svg';
import { ReactComponent as Speed } from 'images/icons-js/Speed.svg';
import { ReactComponent as Branch } from 'images/icons-js/Branch.svg';
import { ReactComponent as GhostAvatar } from 'images/icons-js/GhostAvatar.svg';
import { ReactComponent as HelpIcon } from 'images/icons-js/HelpIcon.svg';
import { ReactComponent as Download } from 'images/icons-js/Download.svg';
import { ReactComponent as LockOpen } from 'images/icons-js/LockOpen.svg';
import { ReactComponent as LockClosed } from 'images/icons-js/LockClosed.svg';
import { ReactComponent as LinkArrow } from 'images/icons-js/LinkArrow.svg';
import { ReactComponent as Pinned } from 'images/icons-js/Pinned.svg';
import { ReactComponent as PinnedOutlined } from 'images/icons-js/PinnedOutlined.svg';
import { ReactComponent as UnPin } from 'images/icons-js/UnPin.svg';
import { ReactComponent as ErrorIcon } from 'images/icons/error-icon.svg';
import { ReactComponent as CoffeeCup } from 'images/icons-js/CoffeeCup.svg';
import { ReactComponent as UserRemove } from 'images/icons-js/UserRemove.svg';
import { ReactComponent as UserUnmerge } from 'images/icons-js/UserUnmerge.svg';
import { ReactComponent as UserMerge } from 'images/icons-js/UserMerge.svg';
import { ReactComponent as UserEditMerge } from 'images/icons-js/UserEditMerge.svg';
import { ReactComponent as Logout } from 'images/icons-js/Logout.svg';
import { ReactComponent as Logo } from 'images/icons-js/Logo.svg';
import { ReactComponent as MenuIcon } from 'images/icons-js/MenuIcon.svg';
import { ReactComponent as InvestmentProfile } from 'images/icons-js/InvestmentProfile.svg';
import { ReactComponent as Bulb } from 'images/icons-js/Bulb.svg';
import { ReactComponent as CycleTime } from 'images/icons-js/CycleTime.svg';
import { ReactComponent as Stars } from 'images/icons-js/stars.svg';
import { ReactComponent as ThreeDots } from 'images/icons-js/ThreeDots.svg';
import { ReactComponent as Filter } from 'images/icons-js/Filters.svg';
import { ReactComponent as Expand } from 'images/icons-js/Expand.svg';
import { ReactComponent as Collapse } from 'images/icons-js/Collapse.svg';
import { ReactComponent as NotificationChat } from 'images/icons-js/NotificationChat.svg';
import { ReactComponent as NotificationChatFull } from 'images/icons-js/NotificationChatFull.svg';
import { ReactComponent as User } from 'images/icons-js/User.svg';
import { ReactComponent as Chart } from 'images/icons-js/Chart.svg';
import { ReactComponent as ChartFull } from 'images/icons-js/ChartFull.svg';
import { ReactComponent as AddChart } from 'images/icons-js/AddChart.svg';
import { ReactComponent as BenchmarkElite } from 'images/icons-js/benchmark_elite.svg';
import { ReactComponent as BenchmarkStrong } from 'images/icons-js/benchmark_strong.svg';
import { ReactComponent as BenchmarkFair } from 'images/icons-js/benchmark_fair.svg';
import { ReactComponent as BenchmarkNeedsFocus } from 'images/icons-js/benchmark_needs_focus.svg';
import { ReactComponent as Trophy } from 'images/icons-js/Trophy.svg';
import { ReactComponent as Delete } from 'images/icons-js/Delete.svg';
import { ReactComponent as MakeAdmin } from 'images/icons-js/MakeAdmin.svg';
import { ReactComponent as Send } from 'images/icons-js/Send.svg';
import { ReactComponent as CopyIcon } from '../../images/icons/copy.svg';
import { ReactComponent as CustomPmMetricsIcon } from '../../images/icons/customPmMetrics.svg';
import { ReactComponent as ViewIcon } from '../../images/icons/view.svg';
import { ReactComponent as HideIcon } from '../../images/icons/hide.svg';
import { ReactComponent as EditUser } from 'images/icons/edit_user.svg';
import { ReactComponent as EditService } from 'images/icons/edit_service.svg';
import { ReactComponent as VPNKey } from 'images/icons/vpn_key.svg';
import { ReactComponent as NotSetup } from 'images/icons/not_setup.svg';
import { ReactComponent as OutlinedStar } from 'images/icons/outlinedStar.svg';
import { ReactComponent as Star } from 'images/icons/star.svg';
import { ReactComponent as gitStreamBlue } from 'images/icons/git-stream-blue.svg';
import { ReactComponent as gitStreamGrey } from 'images/icons/git-stream-grey.svg';
import { ReactComponent as GraphWithFlag } from 'images/icons-js/graph-with-flag.svg';
import { ReactComponent as StatusGood } from 'images/icons/status-good.svg';
import { ReactComponent as StatusFair } from 'images/icons/status-fair.svg';
import { ReactComponent as StatusWarning } from 'images/icons/status-warning.svg';
import { ReactComponent as Target } from 'images/icons-js/target.svg';
import { ReactComponent as PlanningAccuracyGraphLegend } from 'images/icons-js/planning-accuracy-graph-legend.svg';
import { ReactComponent as PlanningAccuracyGraphLegendDash } from 'images/icons-js/planning-accuracy-graph-legend-dash.svg';
import { ReactComponent as GithubIcon } from 'images/icons-js/github-icon.svg';
import { ReactComponent as Cash } from 'images/icons/cash.svg';
import { ReactComponent as OutlinedUser } from 'images/icons/user.svg';
import { ReactComponent as Label } from 'images/icons/label.svg';
import { ReactComponent as Service } from 'images/icons/service.svg';
import { ReactComponent as Repo } from 'images/icons/repo.svg';

import { ReactComponent as Dashboard } from 'images/icons/dashboard.svg';
import { ReactComponent as RoundedClose } from 'images/icons-js/RoundedClose.svg';
import { ReactComponent as RefreshArrows } from 'images/icons-js/refreshArrows.svg';
import { ReactComponent as ArrowLeft } from 'images/icons-js/ArrowLeft.svg';
import { ReactComponent as ArrowRight } from 'images/icons-js/ArrowRight.svg';
import { ReactComponent as ShortcutLogo } from 'images/logos/shortcut-logo.svg';
import { ReactComponent as ChartSideBySide } from 'images/icons-js/chart-side-by-side.svg';
import { ReactComponent as ChartStackedColumn } from 'images/icons-js/chart-stacked-column.svg';
import { ReactComponent as InfoOutlined } from 'images/icons-js/InfoOutlined.svg';
import { ReactComponent as NoEntry } from 'images/icons-js/NoEntry.svg';
import { ReactComponent as ArrowUp } from 'images/icons-js/ArrowUp.svg';
import { ReactComponent as ArrowDown } from 'images/icons-js/ArrowDown.svg';
import { ReactComponent as Cube } from 'images/icons-js/Cube.svg';
import { ReactComponent as LoadMore } from 'images/icons-js/LoadMore.svg';

import CheckIcon from '@material-ui/icons/CheckCircle';

// this isn't used anywhere but can't be deleted yet as it affects tests
/* eslint-disable-next-line */
export const IconWrapper = styled(Flex)`
  background-color: ${getColor('white')};
  ${({ hideBorder }) =>
    `border: 1px solid ${
      hideBorder ? 'transparent' : `${getColor('dodgerBlue', 0.2)}`
    };`}
  ${({ isText }) =>
    isText
      ? `width: auto;  padding: 0.2rem 1.1rem; font-size: 1.2rem; color: ${getColor(
          'chambray'
        )}`
      : `width: 2.2rem`};
  height: 2.2rem;
  border-radius: 0.3rem;
  margin-left: 0.6rem;
  justify-content: center;
  align-items: center;
  ${({ padding }) => (padding ? `padding:${padding};` : '')}
  ${({ clickable }) =>
    clickable &&
    `
    cursor: pointer;
    :hover {
      background-color: ${getColor('titanWhite')};
      border: 1px solid ${getColor('dodgerBlue')};
    }`}
  ${({ isOpen }) =>
    isOpen &&
    `
    background-color:  ${getColor('titanWhite')};
    border: 1px solid ${getColor('dodgerBlue')};`}
`;

export const ICONS_LIST = _.reduce(
  {
    MuiErrorOutline,
    Checkmark,
    Arraw,
    MergedUsers,
    CalendarIcon,
    CloseIcon,
    PeopleIcon,
    AddBoxOutlinedIcon,
    IndeterminateCheckBoxOutlinedIcon,
    Check,
    TrialIcon,
    Deployed: LongLivingIcon,
    ArrowDropDown,
    ControlPoint,
    RepositoriesIcon,
    Productivity,
    Search,
    ChevronRight,
    ChevronLeft,
    KeyboardArrowDown,
    teamwork: TeamworkIcon,
    Throughput,
    Indicators,
    Message,
    quality: QualityIcon,
    newest: NewestIcon,
    BarChart,
    HighlightOff,
    CheckCircleOutlineIcon,
    CheckCircleRoundedIcon,
    WIP: WIPIcon,
    MoreVert,
    Timeline: TimelineIcon,
    MenuIcon,
    'long living': LongLivingIcon,
    SendOutlined,
    DeleteOutlined,
    Done,
    ChangeHistory,
    Warning,
    Add,
    Remove,
    People,
    Close,
    InfoOutlined,
    TeamsPeopleIcon,
    EditOutlinedIcon,
    HourglassEmptyIcon,
    ExpandMore,
    ExpandLess,
    ErrorIcon,
    Pencil,
    Onprem,
    Settings,
    Success,
    Jira,
    Clubhouse,
    Shortcut,
    LinkIcon,
    UnlinkIcon,
    SuccessOutline,
    ErrorOutline,
    WarningOutline,
    Clipboard,
    Clock,
    ClockTime,
    PeopleClock,
    Release,
    Commit,
    PrInitiated,
    PrMerged,
    PrMerged2,
    LongReview,
    ReviewCommented,
    ReviewApproved,
    ReviewChangesRequested,
    PrClosed,
    ChatOutline,
    RepoOwnerOrg,
    RepoOwnerUser,
    AlarmDisabled,
    Alarm,
    AlarmFull,
    Scrum,
    Kanban,
    Projects,
    Accuracy,
    Burnout,
    TopReviewer,
    Speed,
    MoreHoriz,
    StarsBox,
    HumanBubble,
    Envelope,
    EnvelopeWithCheckMark,
    Branch,
    GhostAvatar,
    CheckIcon,
    HandIcon,
    New,
    FiberManualRecordIcon,
    AreaChart,
    HelpIcon,
    Trash,
    Refresh,
    Download,
    LockOpen,
    LockClosed,
    LinkArrow,
    Pinned,
    PinnedOutlined,
    UnPin,
    CoffeeCup,
    UserRemove,
    UserMerge,
    UserUnmerge,
    UserEditMerge,
    Logout,
    Logo,
    InvestmentProfile,
    Bulb,
    CycleTime,
    Stars,
    ThreeDots,
    Filter,
    Expand,
    Collapse,
    NotificationChat,
    NotificationChatFull,
    User,
    Chart,
    ChartFull,
    AddChart,
    CopyIcon,
    CustomPmMetricsIcon,
    ViewIcon,
    HideIcon,
    BenchmarkFair,
    BenchmarkElite,
    BenchmarkNeedsFocus,
    BenchmarkStrong,
    Trophy,
    Delete,
    MakeAdmin,
    Send,
    EditUser,
    EditService,
    VPNKey,
    NotSetup,
    GithubIcon,
    ShortcutLogo,
    OutlinedStar,
    Star,
    Alert,
    gitStreamBlue,
    gitStreamGrey,
    GraphWithFlag,
    StatusGood,
    StatusFair,
    StatusWarning,
    Target,
    PlanningAccuracyGraphLegend,
    PlanningAccuracyGraphLegendDash,
    Cash,
    Dashboard,
    RoundedClose,
    RefreshArrows,
    ArrowLeft,
    ArrowRight,
    ChartSideBySide,
    ChartStackedColumn,
    Wrench,
    NoEntry,
    ArrowUp,
    ArrowDown,
    Cube,
    OutlinedUser,
    Repo,
    Service,
    Label,
    LoadMore,
    AzureBoards
  },
  (acc, val, key) => {
    acc[key.toLowerCase()] = val;
    return acc;
  },
  {}
);

const DIRECTIONS = {
  left: 'rotate(90)',
  right: 'rotate(270)',
  'up-right': 'rotate(225)',
  up: 'rotate(180)',
  'up-left': 'rotate(135)',
  down: 'rotate(0)',
  'down-left': 'rotate(45)',
  'down-right': 'rotate(315)'
};

// eslint-disable-next-line
/**
 * @deprecated Please use the filters available in `@linearb/linui-common`
 */
export default class Icon extends Component {
  render() {
    const {
      color = 'chambray',
      alpha,
      isThin = false,
      size = 'small',
      name = '',
      direction,
      viewBox,
      onClick,
      style,
      ...rest
    } = this.props;

    const DynamicIcon = ICONS_LIST[name.toLowerCase()];

    const transform = direction ? { transform: DIRECTIONS[direction] } : {}; // TODO: Handle transform

    if (!DynamicIcon) {
      throw new Error(`ICON ${name} does not exists in icons list`);
    }

    return (
      <DynamicIcon
        id={name}
        style={{
          fontSize: ICON_SIZES[size],
          color: getColor(color, alpha),
          ...(isThin ? { strokeWidth: 0.5 } : {}),
          ...(onClick ? { cursor: 'pointer' } : {}),
          ...style
        }}
        onClick={onClick}
        {...transform}
        {...rest}
      />
    );
  }
}
